module.exports = __webpack_public_path__ + "img/img4.ae981ad9.png";